import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAppqaOZfSkPkDMI6_GjUwiyVO6konz9h0",
  authDomain: "mybracketonline-7f251.firebaseapp.com",
  projectId: "mybracketonline-7f251",
  storageBucket: "mybracketonline-7f251.firebasestorage.app",
  messagingSenderId: "384127743581",
  appId: "1:384127743581:web:05d63b00cfec3aff8fbfb4",
  measurementId: "G-KG10D5E324"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };